import { splitMarkdownToBranches } from '@/scripts/planA/splitMarkdownToBranches'
import type { ResolvedBranchesData, UnifiedBranchesData } from '@/lib/branchTypes'
import { resolveBranchContentFromMemory } from './resolveBranchContentFromMemory'
import { splitFootnotesFromFullMarkdown } from './splitFootnotes'

// Turn a full story markdown string into the in-memory branch graph the
// playbook renders, without touching the filesystem. Returns null when the
// markdown is empty or doesn't have the anchors the splitter expects
// (:::timelineDiagram / # H1 / 2029 dateMarker) so callers can fall back to a flat
// preview. Shared by PreviewColumn and the editor's home preview so both
// resolve identically.
export function resolveBranchDataFromMarkdown(
  markdown: string,
  existingUnifiedJson: UnifiedBranchesData,
): ResolvedBranchesData | null {
  if (!markdown.trim()) return null
  try {
    const { bodyMarkdown, footnotesContent } = splitFootnotesFromFullMarkdown(markdown)
    const { unifiedJson, chunkContents } = splitMarkdownToBranches({
      markdown: bodyMarkdown,
      footnotesContent,
      existingUnifiedJson,
    })
    return resolveBranchContentFromMemory({ unifiedJson, chunkContents })
  } catch {
    return null
  }
}
